<template>
  <el-popconfirm
    title="Удалить, вы уверены?"
    confirm-button-text="Да"
    @confirm="deleteClick"
  >
    <template #reference>
      <el-button
        icon="el-icon-delete"
        size="small"
        type="danger"
      >
        {{ title }}
      </el-button>
    </template>
  </el-popconfirm>
</template>

<script>
export default {
  name: 'UiDeleteButton',
  props: {
    title: {
      type: String,
      default: 'Удалить',
    },
  },
  methods: {
    deleteClick() {
      this.$emit('delete');
    },
  },
};
</script>
